import { useAuth } from "../contexts/authContext";
import { Navigate, Link } from "react-router-dom";
import { useState } from "react";
import { doCreateUserWithEmailAndPassword } from "../backend/auth";

const Register = () => {
  const { userLoggedIn } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsRegistering(true);
    if (password !== confirmPassword) {
      setErrorMessage("Passwords do not match");
      setIsRegistering(false);
      return;
    }
    try {
      await doCreateUserWithEmailAndPassword(email, password);
    } catch (error) {
      setErrorMessage(error.message);
      setIsRegistering(false);
      return;
    }
  };

  return (
    <>
      {userLoggedIn && <Navigate to={"/profile"} replace={true} />}
      <main className="w-full h-screen flex self-center place-content-center place-items-center bg-main_dark">
        <div className="w-4/5 lg:w-2/5 text-sub space-y-5 p-4 shadow-xl border rounded-xl bg-card">
          <div className="text-center mb-6">
            <div className="mt-2">
              <h3 className="text-xl font-semibold sm:text-2xl">
                Create a New Account
              </h3>
            </div>
          </div>
          <form onSubmit={onSubmit} className="space-y-4 ">
            <div>
              <label className="text-sm text-gray-600 font-bold">Email</label>
              <input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                className="w-full mt-2 px-3 py-2 text-gray-500 border-gray-400 bg-transparent outline-none border focus:indigo-600 shadow-sm rounded-lg transition duration-300"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600 font-bold">
                Password
              </label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete="new-password"
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                className="w-full mt-2 px-3 py-2 text-gray-500  border-gray-400 bg-transparent outline-none border focus:border-sub shadow-sm rounded-lg transition duration-300"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600 font-bold">
                Confirm Password
              </label>
              <input
                disabled={isRegistering}
                type="password"
                autoComplete="off"
                required
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                }}
                className="w-full mt-2 px-3 py-2 text-gray-500 border border-gray-400 bg-transparent outline-none  focus:border-sub shadow-sm rounded-lg transition duration-300"
              />
            </div>

            {errorMessage && (
              <span className="text-red-600 font-bold">{errorMessage}</span>
            )}

            <button
              type="submit"
              disabled={isRegistering}
              className={`w-full px-4 py-2  font-medium rounded-lg border-solid border-2 border-sub text-white  ${
                isRegistering
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-deco  hover:shadow-xl transition duration-300"
              }`}
            >
              {isRegistering ? "Signing Up..." : "Sign Up"}
            </button>
            <div className="text-sm text-center">
              Already have an account? {"   "}
              <Link
                to={"/login"}
                className="text-center text-sm hover:underline font-bold"
              >
                Continue
              </Link>
            </div>
          </form>
        </div>
      </main>
    </>
  );
};

export default Register;
